// extracted by mini-css-extract-plugin
module.exports = {"box":"box_box__PDI8s","large":"box_large___43rD","bgTransparent":"box_bgTransparent__4_9gk","bgLinkWater":"box_bgLinkWater__bCHsA","image":"box_image__hVwZ0"};